module.exports = "\n<link rel=\"stylesheet\" href=\"../../assets/vendor/bootstrap/css/bootstrap.css\">\n<div class=\"container\">\n\n<app-sidebar (collapsedEvent)=\"receiveCollapsed($event)\"></app-sidebar>\n  <div class=\"mleft\" > <app-header></app-header></div>\n <section class=\"main-container\" [ngClass]=\"{collapsed: collapedSideBar}\">\n\n    <router-outlet></router-outlet>\n</section>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/layout.component.html
// module id = ../../../../../src/app/layout/layout.component.html
// module chunks = main